import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  checkArray,
  decimalValue,
  getMerchantCurrencySymbol,
} from "../../../../helpers";
import {
  changePendIngredientStatus,
  changeMenuValue,
  getIngrRecMenuPendingApproval,
  changePendRecipeStatus,
} from "../../../../Redux/actions";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const PendingApproval = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user_details = useSelector((state) => state.authReducer.user_details);
  const { ingredient_details } = useSelector((state) => state.menuReducer);

  useEffect(() => {
    dispatch(getIngrRecMenuPendingApproval());

    return () => {
      dispatch(changeMenuValue("ingredient_details", null));
    };
  }, []);

  const [selectedRecipe, setSelectedRecipe] = useState([]);

  const recipeSelectHandler = (recipeId) => {
    const newRecipeIdArr = [...selectedRecipe];
    if (selectedRecipe.indexOf(recipeId) > -1) {
      newRecipeIdArr.splice(selectedRecipe.indexOf(recipeId), 1);
    } else {
      newRecipeIdArr.push(recipeId);
    }
    setSelectedRecipe(newRecipeIdArr);
  };
  const [selectedIngre, setSelectedIngre] = useState([]);

  const ingreSelectHandler = (ingreId) => {
    const newIngreIdArr = [...selectedIngre];
    if (selectedIngre.indexOf(ingreId) > -1) {
      newIngreIdArr.splice(selectedIngre.indexOf(ingreId), 1);
    } else {
      newIngreIdArr.push(ingreId);
    }
    setSelectedRecipe(newIngreIdArr);
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass my-4">
              <h4 class="event-alert green-text">
                {" "}
                Ingr./Rec./Menu Items Pending Approval{" "}
              </h4>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">Ingredients</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th width="35"> </th>
                                <th> Ingredient Name </th>
                                <th> Added By </th>
                                <th> Category </th>
                                {/* <th> Measurement Units </th> */}
                                <th> Finance Payee Name </th>
                                <th className="action-td">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(ingredient_details?.ingredients) &&
                                ingredient_details?.ingredients.map((ingre) => {
                                  return (
                                    <tr>
                                      <td className="text-center">
                                        <a class="checkbox avaiCheck">
                                          <input
                                            type="checkbox"
                                            id={`test${ingre?.id}`}
                                            className="avail_checkbox"
                                            onClick={() =>
                                              ingreSelectHandler(ingre?.id)
                                            }
                                            checked={
                                              selectedRecipe.indexOf(
                                                ingre?.id
                                              ) > -1
                                            }
                                          />
                                          <label for={`test${ingre?.id}`}>
                                            {" "}
                                          </label>
                                        </a>
                                      </td>
                                      <td class="">
                                        <div class="event-time-edit p0">
                                          <span>
                                            <input
                                              type="hidden"
                                              name="data[IngredientsRecipe][0][category_id]"
                                              value="9"
                                              class="edit_c_id"
                                            />
                                            {ingre?.ingredient_name}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        {ingre?.user?.first_name}{" "}
                                        {ingre?.user?.last_name}
                                      </td>
                                      <td> {ingre?.category?.name} </td>
                                      {/* <td>$135.91</td> */}
                                      <td>
                                        {checkArray(
                                          ingre?.ingredient_conv_multiplier
                                        ) &&
                                          ingre?.ingredient_conv_multiplier.map(
                                            (conv) => {
                                              return (
                                                <>
                                                  <span>
                                                    {
                                                      conv?.FinancePayee
                                                        ?.payee_name
                                                    }
                                                  </span>
                                                  <br />
                                                </>
                                              );
                                            }
                                          )}
                                      </td>
                                      <td>
                                        <div class="event-time-edit p0">
                                          {/* TODO */}
                                          {/* <a class="editComponent" href="#_">
                                            <i class="iconSprites edit-icon"></i>
                                          </a> */}
                                          <button
                                            class="btn btn_btnblue"
                                            onClick={() =>
                                              dispatch(
                                                changePendIngredientStatus({
                                                  temp_id: [ingre?.id],
                                                  status: "approve",
                                                })
                                              )
                                            }
                                          >
                                            Approve
                                          </button>
                                          <button
                                            class="btn btn_btnblack"
                                            onClick={() =>
                                              dispatch(
                                                changePendIngredientStatus({
                                                  temp_id: [ingre?.id],
                                                  status: "reject",
                                                })
                                              )
                                            }
                                          >
                                            Reject
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="clearfix"></div>
                      <div class="row mx-0">
                        <div class="container px-0 d-flex col-12">
                          <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                            <div class="event-time-edit p0">
                              {/* TODO */}
                              {/* <a class="editComponent" href="#_">
                                            <i class="iconSprites edit-icon"></i>
                                          </a> */}
                              <button
                                class="btn btn_btnblue"
                                onClick={() =>
                                  dispatch(
                                    changePendIngredientStatus({
                                      temp_id: selectedIngre,
                                      status: "approve",
                                    })
                                  )
                                }
                              >
                                Approve
                              </button>
                              <button
                                class="btn btn_btnblack cancel"
                                onClick={() =>
                                  dispatch(
                                    changePendIngredientStatus({
                                      temp_id: selectedIngre,
                                      status: "reject",
                                    })
                                  )
                                }
                              >
                                Reject
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">Receipes List</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingTwo"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th width="35"> </th>
                                <th> Ingredient Name </th>
                                <th> Added By </th>
                                <th> Category </th>
                                <th> Measurement Units </th>
                                <th> Finance Payee Name </th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(ingredient_details?.recipes) &&
                                ingredient_details?.recipes.map((recipe) => {
                                  return (
                                    <tr>
                                      <td className="text-center">
                                        <a class="checkbox avaiCheck">
                                          <input
                                            type="checkbox"
                                            id={`test${recipe?.id}`}
                                            className="avail_checkbox"
                                            onClick={() =>
                                              recipeSelectHandler(recipe?.id)
                                            }
                                            checked={
                                              selectedRecipe.indexOf(
                                                recipe?.id
                                              ) > -1
                                            }
                                          />
                                          <label for={`test${recipe?.id}`}>
                                            {" "}
                                          </label>
                                        </a>
                                      </td>
                                      <td class="">
                                        <div class="event-time-edit p0">
                                          <span>
                                            <input
                                              type="hidden"
                                              name="data[IngredientsRecipe][0][category_id]"
                                              value="9"
                                              class="edit_c_id"
                                            />
                                            {recipe?.recipe_name}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        {recipe?.user?.first_name}{" "}
                                        {recipe?.user?.last_name}
                                      </td>
                                      <td> {recipe?.menu_class?.name} </td>
                                      <td>{recipe?.number_of_servings}</td>
                                      <td>
                                        {decimalValue(
                                          recipe?.total_recipe_cost,
                                          2,
                                          getMerchantCurrencySymbol(
                                            user_details
                                          )
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="clearfix"></div>
                      <div class="row mx-0">
                        <div class="container px-0 d-flex col-12">
                          <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                            <div class="event-time-edit p0">
                              {/* TODO */}
                              {/* <a class="editComponent" href="#_">
                                            <i class="iconSprites edit-icon"></i>
                                          </a> */}
                              <button
                                class="btn btn_btnblue"
                                onClick={() =>
                                  dispatch(
                                    changePendRecipeStatus({
                                      temp_id: selectedRecipe,
                                      status: "approve",
                                    })
                                  )
                                }
                              >
                                Approve
                              </button>
                              <button
                                class="btn btn_btnblack cancel"
                                onClick={() =>
                                  dispatch(
                                    changePendRecipeStatus({
                                      temp_id: selectedRecipe,
                                      status: "reject",
                                    })
                                  )
                                }
                              >
                                Reject
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingThree"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseThree"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseThree"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">Menu Items</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseThree"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingThree"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th> Ingredient Name </th>
                                <th> Added By </th>
                                <th> Category </th>
                                <th> Measurement Units </th>
                                <th> Finance Payee Name </th>
                                <th className="action-td">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* <tr>
                                <td class="">
                                  <div class="event-time-edit p0">
                                    <span>
                                      <input
                                        type="hidden"
                                        name="data[IngredientsRecipe][0][category_id]"
                                        value="9"
                                        class="edit_c_id"
                                      />
                                      Beer
                                    </span>
                                  </div>
                                </td>
                                <td>Erdinger Weiss Draught</td>
                                <td> 12,221.00000 Milliliters </td>
                                <td>$135.91</td>
                                <td>100.00%</td>
                                <td>
                                  <div class="event-time-edit p0">
                                    <a class="editComponent" href="#_">
                                      <i class="iconSprites edit-icon"></i>
                                    </a>
                                    <a class="circle_icon" href="#_">
                                      <i class="iconSprites delete-icon"></i>
                                    </a>
                                  </div>
                                </td>
                              </tr> */}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default PendingApproval;
